import r from"./isObject.js";var t=r;var a=function(r){return r==r&&!t(r)};export{a as default};
//# sourceMappingURL=_isStrictComparable.js.map
